<template>
  <!-- 个人中心粉丝分析页面 -->
  <div class="right">
    <el-main>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="基础数据" name="first">
          <el-row>
            <el-col>
            </el-col><br /><br />
            <el-col :span="24">
              <div class="grid-content bg-purple-dark">
                <ul>
                  <li>昨日关键指标</li>
                </ul>
              </div>
            </el-col>
            <el-col :span="24">
              <div class="ites grid-content bg-purple-dark">
                <div id="ite">
                  <div class="ite-title">
                    <span>新增粉丝</span>&nbsp;&nbsp;
                    <el-tooltip content="昨日相比于前日新增的粉丝数" placement="bottom" effect="light">
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                    <p class="c666">
                      {{fansdata.fans_num}}
                    </p>
                    <div class="c666">日：0</div>
                  </div>
                </div>

                <div id="ite">
                  <div class="ite-title">
                    <span>取消关注</span>&nbsp;&nbsp;
                    <el-tooltip content="昨日取消关注本账号的粉丝数" placement="bottom" effect="light">
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                    <p>
                      {{fansdata.cancel_num}}
                    </p>
                    <div class="c666" style="visibility: hidden;">日：0</div>
                  </div>
                </div>

                <div id="ite">
                  <div class="ite-title">
                    <span>净增粉丝  </span>&nbsp;&nbsp;
                    <el-tooltip content="昨日取消关注本账号的粉丝数" placement="bottom" effect="light">
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                    <p>
                      {{fansdata.clean_num}}
                    </p>
                    <div class="c666" style="visibility: hidden;">日：0</div>
                  </div>
                </div>

                <div id="ite">
                  <div class="ite-title">
                    <span>粉丝总人数  </span>&nbsp;&nbsp;
                    <el-tooltip content="昨日取消关注本账号的粉丝数" placement="bottom" effect="light">
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                    <p>
                      {{fansdata.total_num}}
                    </p>
                    <div class="c666" style="visibility: hidden;">日：0</div>
                  </div>
                </div>


              </div>
            </el-col>

            <el-col :span="24" style="margin-top: 20px;">
              <div class="grid-content bg-purple-dark">
                <ul>
                  <li>月度关键数据</li>
                </ul>
              </div>
            </el-col>

            <el-col :span="24">
              <div class="ites grid-content bg-purple-dark">
                <div id="ite" style="cursor: pointer;">
                  <div class="ite-title">
                    <span>粉丝月度累计阅读量</span>&nbsp;&nbsp;
                    <el-tooltip content="昨日相比于前日新增的粉丝数" placement="bottom" effect="light">
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                    <p class="c666">
                      {{fansdata.read_num}}
                    </p>
                    <div class="c666">月度累计阅读数：0</div>
                  </div>
                </div>
                <div id="ite" style="cursor: pointer;">
                  <div class="ite-title">
                    <span>粉丝月度累计收益</span>&nbsp;&nbsp;
                    <el-tooltip content="昨日取消关注本账号的粉丝数" placement="bottom" effect="light">
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                    <p class="c666">0</p>
                    <div class="c666">月度累计收益： {{fansdata.profit_num}}元</div>
                  </div>
                </div>
              </div>
            </el-col>

            <el-col :span="24">
              <div class="grid-content bg-purple-dark">
                <ul class="rqxz">
                  <li>日期选择</li>
                  <li @click="changeDay(7)" class="active">
                    <a href="javascript:;">7日</a>
                  </li>
                  <li @click="changeDay(14)">
                    <a href="javascript:;">14日</a>
                  </li>
                  <li @click="changeDay(30)">
                    <a href="javascript:;">30日</a>
                  </li>
                </ul>
              </div>
            </el-col>

            <el-col :span="24">
              <div class="grid-content bg-purple-dark">
                <div id="myChart" style="width: 980px;height: 400px;"></div>
              </div>
              <br /><br />
              <el-table :data="tableData2" style="width: 940px;padding-left:3rem;" :row-class-name="tableRowClassName">
                <el-table-column prop="date" label="时间">
                </el-table-column>
                <el-table-column prop="save_num" label="新增粉丝">
                </el-table-column>
                <el-table-column prop="del_num" label="取消关注">
                </el-table-column>
                <el-table-column prop="clean_num" label="净增粉丝">
                </el-table-column>
                <el-table-column prop="total_num" label="粉丝总数">
                </el-table-column>
              </el-table>
            </el-col>
            <br /><br /><br /><br />
            <el-col :span="24">

            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </el-main>
  </div>
</template>

<script>
    import Axios from "axios"
//   import { WebFansCurve } from '@/request/api' //曲线图数据
//   import { FansData } from '@/request/api'  //昨日及月度数据
//   import { RelationFansData } from '@/request/api'  //粉丝分析 表格数据
  export default {
    metaInfo(){
     return{
        title: '粉丝分析',
        meta: [
            {
                name: 'keywords',
                content: '驱动中国研究院是一家全行业的自媒体平台，提供新闻资讯聚合数据挖掘与引擎算法智能推荐。提供个性化资讯服务，全方位打造商圈自媒体平台，提供连接人与信息的智能服务，打造国内有价值的移动自媒体平台。'
            },
            {
                name: 'description',
                content:' 驱动中国研究院，专利转让，研究报告，科研资讯，驱动中国研究院官网'
            }
        ]
     }     
    },
    name: 'dataAnyCotent',
    data() {
      return {
        msg: 'cdn形式',
        activeName: 'first',
        day:7,
        fansdata:[],
        options: {
          title: {
            text: '',
            textStyle: {
              fontWeight: 'normal',
              fontSize: '0.8em'
            },
            left: '30px'
          },
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            icon: 'emptyCircle',
            data: ['新增粉丝', '取消关注', '净增粉丝', '粉丝总数'],
            selectedMode: 'single',
            orient: 'horizontal', // 'vertical'
            x: 30, // 'center' | 'left' | {number},
            y: 'top', // 'center' | 'bottom' | {number}
            backgroundColor: '#fff',
            padding: 5, // [5, 10, 15, 20]
            itemGap: 10,
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          toolbox: {
            feature: {
              saveAsImage: {}
            }
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: ['20190921', '20190922', '20190923', '20190924', '20190925', '20190926', '20190927']
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
            name: '新增粉丝',
            type: 'line',
            stack: '总量',
            data: [120, 132, 101, 134, 90, 230, 210]
          },
            {
              name: '取消关注',
              type: 'line',
              stack: '总量',
              data: [2, 20, 19, 33, 0, 12, 5]
            },
            {
              name: '净增粉丝',
              type: 'line',
              stack: '总量',
              data: [150, 232, -20, 154, 190, 330, 410]
            },
            {
              name: '粉丝总数',
              type: 'line',
              stack: '总量',
              data: [1000, 33000, 102, 55000, 5958, 3300, 2535]
            }
          ]
        },
        tableData2: []
      };
    },
    methods: {
      handleClick(tab, event) {
        ////console.log(tab, event);
      },
      tableRowClassName({ row, rowIndex }) {
        ////console.log(row, rowIndex);
        if(row.jingFen < 0){

        }
      },
      //修改数据图的天数
      changeDay:function(day){
        this.day = day
        this.getLineData()
      },
      getLineData:function (e) {
      Axios({
      method: "post",
      url: "https://researchadmin.qudong.com/api/relation/web_fans_curve",
      headers:{
        'token':localStorage.getItem('token')
      },
      params: {
       content_type:this.content_type,status:this.status,page:this.page,limit:this.limit,day:this.day
      },
    }).then((res) => {
         ////console.log("粉丝分析曲线图数据")
          //['新增粉丝', '取消关注', '净增粉丝', '粉丝总数'],
          this.options.xAxis.data = res.data.data.date;
          this.options.series[0].data = res.data.data.save;
          this.options.series[1].data = res.data.data.del;
          this.options.series[2].data = res.data.data.clean;
          this.options.series[3].data = res.data.data.total;
          ////console.log(this.options)
    });
        // WebFansCurve({content_type:this.content_type,status:this.status,page:this.page,limit:this.limit,day:this.day}).then(res=>{
        //   ////console.log("粉丝分析曲线图数据")
        //   //['新增粉丝', '取消关注', '净增粉丝', '粉丝总数'],
        //   this.options.xAxis.data = res.data.date;
        //   this.options.series[0].data = res.data.save;
        //   this.options.series[1].data = res.data.del;
        //   this.options.series[2].data = res.data.clean;
        //   this.options.series[3].data = res.data.total;
        //   ////console.log(this.options)
        // }).catch(res=>{
        //   ////console.log("评论列表获取失败");
        // })
      },
      //FansData
      getFansData:function (e) {
          Axios({
      method: "post",
      url: "https://researchadmin.qudong.com/api/relation/fans_data",
      headers:{
        'token':localStorage.getItem('token')
      },
      params: {
       content_type:this.content_type,status:this.status,page:this.page,limit:this.limit
      },
    }).then((res) => {
     ////console.log(res)
          this.fansdata = res.data.data;
    });
        // FansData({content_type:this.content_type,status:this.status,page:this.page,limit:this.limit}).then(res=>{
        //   ////console.log(res)
        //   this.fansdata = res.data;
        // }).catch(res=>{
        //   ////console.log("评论列表获取失败");
        // })
      },
      //
      //获取表格数据
      GetRelationFansData:function (e) {
          Axios({
      method: "post",
      url: "https://researchadmin.qudong.com/api/Relation/web_fans_data",
      headers:{
        'token':localStorage.getItem('token')
      },
      params: {
       content_type:this.content_type,status:this.status,page:this.page,limit:this.limit
      },
    }).then((res) => {

          this.tableData2 = res.data.data.data;
           ////console.log(this.tableData2)
    });
        // RelationFansData({content_type:this.content_type,status:this.status,page:this.page,limit:this.limit}).then(res=>{
        //   ////console.log(res)
        //   this.tableData2 = res.data.data;
        // }).catch(res=>{
        //   ////console.log("评论列表获取失败");
        // })
      },
      init:function (e) {
        let myChart = this.$echarts.init(document.getElementById('myChart'))
        // 绘制图表
        myChart.setOption(this.options,true);
      }
    },
    watch: {
      //观察option的变化
      options: {
        handler(newVal, oldVal) {
          if (this.myChart) {
            if (newVal) {
              this.myChart.setOption(newVal);
            } else {
              this.myChart.setOption(oldVal);
            }
          } else {
            this.init();
          }
        },
        deep: true //对象内部属性的监听，关键。
      }
    },
    created() {

    },
    mounted() {
      this.getLineData();
      this.getFansData();
      this.GetRelationFansData();
    }
  }
</script>

<style scoped>  
  /* @import "../../assets/base.css"; */
  body>.el-container {
    margin-bottom: 40px;
  }
    .right{
        background:#fff;
    }
  .el-container .el-container {
    width: 980px;
    margin: 0 auto;
  }

  .el-col {
    border-radius: 4px;
  }

  .bg-purple-dark {
    background: #FFF;
    position: relative;
  }


  #ite{
    width: 24%;
    border-right: 1px solid #eee;
    display: inline-block;
  }

  #ite:last-child{
    border: none;
  }

  .ites{
    padding: 2rem 0;
    border-bottom: 1px solid #eee;
  }

  #ite .ite-title{
    width: 100%;
    color: #333;
    text-align: center;
  }

  #ite .ite-title p{
    font-size: 2em;
    font-weight: bold;
    margin: 8px auto;
  }

  .el-table div{
    text-align: center;
  }

  .bg-purple {
    background: #d3dce6;
  }

  .bg-purple-light {
    background: #e5e9f2;
  }

  .grid-content {
    border-radius: 4px;
    min-height: 36px;
  }

  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }

  .rqxz li{
    float: left;
    margin-right: 20px;
    font-size: 16px!important;
  }
  .rqxz li a{
    color: #409EFF;
  }
  .tips{
    font-size: 15px;
    color: #f83a3a;
  }
  .rqxz .active{
    color: #f83a3a;
  }
  .el-input__inner,.el-button,.el-upload--picture-card{
    border-radius: 0px;
}
.ite-title span{
    font-size: 14px;
    color: #666;
}
.c666{
    color: #666;
}
.rqxz{
    display: table;
    text-align: center;
    margin: 60px auto !important;
    overflow: hidden;
  }
.bg-purple-dark ul li{
    font-size: 16px;
    font-weight: 700;
}
#ite .ite-title p,.ite .ite-title p{
    font-size: 3em !important;
}
</style>